
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponsorship",
      function () {
        return require("private-next-pages/sponsorship.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sponsorship"])
      });
    }
  